var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarrantIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66536 1H14.9987C15.1755 1 15.3451 1.07024 15.4701 1.19526C15.5951 1.32029 15.6654 1.48986 15.6654 1.66667V15C15.6654 15.1768 15.5951 15.3464 15.4701 15.4714C15.3451 15.5964 15.1755 15.6667 14.9987 15.6667H0.998698C0.821887 15.6667 0.652318 15.5964 0.527293 15.4714C0.402269 15.3464 0.332031 15.1768 0.332031 15V1.66667C0.332031 1.48986 0.402269 1.32029 0.527293 1.19526C0.652318 1.07024 0.821887 1 0.998698 1H2.9987",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66476 6.99937C7.66476 7.36603 7.46476 7.44003 7.22543 7.1647L5.33143 4.99936L3.43543 7.16337C3.19343 7.43937 2.99609 7.36336 2.99609 6.9987V0.998698C2.99609 0.821887 3.06633 0.652318 3.19136 0.527293C3.31638 0.402269 3.48595 0.332031 3.66276 0.332031H6.99609C7.1729 0.332031 7.34247 0.402269 7.4675 0.527293C7.59252 0.652318 7.66276 0.821887 7.66276 0.998698L7.66476 6.99937Z",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66406 4.33203H13.6641",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66406 7H13.6641",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33203 9.66406H13.6654",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33203 12.332H13.33",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantIcon);
export default __webpack_public_path__ + "static/media/warrantIcon.835e35e35caaa49141a03ed0c11edac6.svg";
export { ForwardRef as ReactComponent };